import request from '@/assets/util/request'   //ajax请求

export const creditList = (data)=> {
    return request({
        url: `/agent/api/company/credit/list`,
        method: 'post',
        data: data,
        params:data
    })
}

export const personCreditList = (data)=> {
    return request({
        url: `/agent/api/employee/credit/list`,
        method: 'post',
        data: data,
        params:data
    })
}



